<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-11">
        <div class="columns">
          <div class="column is-3">
            <div
              v-if="prev"
              class="screen-nav-link left"
            >
              <router-link :to="prev">
                <i class="fad fa-chevron-double-left 2x" /> Back
              </router-link>
              <div>
                <small>Back to {{ prev.meta.label }}</small>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="screen-nav-title has-text-centered">
              <h2 class="title is-2">
                <template v-if="this.$route.name !== 'file-now'">
                  {{ currentFilingYear }}
                </template>
                Financial Disclosure Statements
              </h2>
            </div>
          </div>
          <div class="column is-3 has-text-right">
            <div
              v-if="next.name"
              class="screen-nav-link left"
            >
              <a
                href="#"
                @click="formInstructionsModalOptions"
              >Form Instructions <i class="fad fa-info-square" /></a>
              <p class="is-small">
                Click to get guidance in filling out forms
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormInstructions from '@/modals/FormInstructions';
import { filerScreenHelpers } from '@/mixins/filerScreen';
export default {
  name: 'FilerScreenNav',
  components: {},
  mixins: [
    filerScreenHelpers,
  ],
  data () {
    return {
      next: {
        name: 'filing-instructions',
      },
      prev: null,
    };
  },
  computed: {
    currentFilingYear () {
      let filing = this.getCurrentFiling();
      if (filing) {
        return filing.year;
      }
      return '';
    },
    filingScreens () {
      return this.$store.getters[ 'filings/filingScreens']('filing');
    },
  },
  watch: {
    '$route' () {
      this.setPrevScreen();
    },
  },
  async created () {
    this.setPrevScreen();
  },
  methods: {
    setPrevScreen () {
      let prevRouteIndex = this.filingScreens.indexOf(this.$route.name) - 1;
      if (prevRouteIndex >= 0) {
        let prevRouteName = this.filingScreens[prevRouteIndex];
        //exception for user-profile-update which should not be accessed by going to a previous route
        if (prevRouteName === 'user-profile-update') {
          prevRouteIndex = prevRouteIndex - 1;
          prevRouteName = this.filingScreens[prevRouteIndex];
        }

        let prevRoute = this.$router.resolve({ name: prevRouteName });
        this.prev = { ...prevRoute.route };
      }
      if (this.$route.name === 'statements-submitted') {
        this.prev = null;
      }
    },
    formInstructionsModalOptions () {
      this.$modal.show(
        FormInstructions,
        null,
        {
          height: 'auto',
          width: 460,
          classes: "is-small",
        },
      );
    },
  },
};
</script>